import getDefaultState from './state';

export function flush(state) {
  Object.assign(state, getDefaultState());
}

export function updateCurrentCategory(state, { category }) {
  state.current = category;
}

export function updateCategories(state, { categories }) {
  // Sort all resources by name by default
  categories.sort((a, b) => new Intl.Collator('is').compare(a.name, b.name));
  state.all = categories;
}

export function updateAvailableCategories(state, { categories }) {
  // Sort all resources by name by default
  categories.sort((a, b) => new Intl.Collator('is').compare(a.name, b.name));

  // Move child categories under the parent
  categories.forEach((c) => {
    if (c.parentId) {
      const parentIndex = categories.findIndex((p) => p.id === c.parentId);
      if (parentIndex > -1) {
        if (!categories[parentIndex].children) {
          categories[parentIndex].children = [];
        }
        categories[parentIndex].children.push(c);
      }
    }
  });

  // Only store the root categories
  const roots = categories.filter((c) => !c.parentId);

  // Recreate the final array
  const sorted = [];
  roots.forEach((lvl1) => {
    sorted.push(lvl1);

    if (lvl1.children?.length > 0) {
      lvl1.children.forEach((lvl2) => {
        lvl2.name = `- ${lvl2.name}`;
        sorted.push(lvl2);

        if (lvl2.children?.length > 0) {
          lvl2.children.forEach((lvl3) => {
            lvl3.name = `-- ${lvl3.name}`;
            sorted.push(lvl3);
          });
        }
      });
    }
  });

  state.available = sorted;
}

export function updateFilter(state, { filter }) {
  state.filter = filter;
}

export function updateMeta(state, { meta }) {
  state.meta = meta;
}
